import React from "react";
import { AppColors } from "../css/AppColors";
import { Button } from 'react-bootstrap';
import {BrowserRouter as Router,useHistory} from "react-router-dom"
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

const BackButton = () => {
    const history = useHistory();

    return (
        <Button
            className="btn btn-primary btn-user btn-block rBBtn"
            onClick={history.goBack}
            style={{ backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo', marginTop: 10 }}
        >
            Back
        </Button>
    );
};

export default BackButton